(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-card-wrapper').forEach(function(wrapper) {
    var link = wrapper.querySelector('.card-collection__cover-link');
    if (!link) return;
    wrapper.style.cursor = 'pointer';
    wrapper.addEventListener('click', function(e) {
      var clicked = e.target.closest('a[href]');
      if (clicked && clicked !== link) return;
      window.location.href = link.getAttribute('href');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function buildSwatches() {
    var wrappers = document.querySelectorAll('.product-card-wrapper');
    if (!wrappers.length) return;

    var products = [];
    for (var i = 0; i < wrappers.length; i++) {
      var anchor = wrappers[i].querySelector('.card__heading a');
      if (!anchor) continue;
      var parsed = extractColor(anchor.textContent.trim());
      products.push({ wrapper: wrappers[i], title: anchor.textContent.trim(), url: anchor.getAttribute('href'), color: parsed.color, baseName: parsed.baseName });
    }

    var groups = {};
    for (var j = 0; j < products.length; j++) {
      if (!products[j].color) continue;
      var key = products[j].baseName.toLowerCase().trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(products[j]);
    }

    var keys = Object.keys(groups);
    for (var k = 0; k < keys.length; k++) {
      var group = groups[keys[k]];
      for (var m = 0; m < group.length; m++) {
        var current = group[m];
        var infoEl = current.wrapper.querySelector('.card-information');
        if (!infoEl || infoEl.querySelector('.card-swatches')) continue;
        var row = document.createElement('div');
        row.className = 'card-swatches';
        row.setAttribute('aria-label', 'Available colours');
        for (var n = 0; n < group.length; n++) {
          var sib = group[n];
          var a = document.createElement('a');
          a.href = sib.url;
          a.className = 'card-swatch' + (sib === current ? ' card-swatch--active' : '');
          a.setAttribute('title', sib.title);
          var dot = document.createElement('span');
          dot.className = 'card-swatch__dot';
          if (COLOR_HEX[sib.color]) dot.style.backgroundColor = COLOR_HEX[sib.color];
          a.appendChild(dot);
          row.appendChild(a);
        }
        infoEl.appendChild(row);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSwatches);
  } else {
    buildSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(function () {
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function buildSwatches() {
    var wrappers = document.querySelectorAll('.product-card-wrapper');
    if (!wrappers.length) return;

    var products = [];
    for (var i = 0; i < wrappers.length; i++) {
      var anchor = wrappers[i].querySelector('.card__heading a');
      if (!anchor) continue;
      var parsed = extractColor(anchor.textContent.trim());
      products.push({ wrapper: wrappers[i], title: anchor.textContent.trim(), url: anchor.getAttribute('href'), color: parsed.color, baseName: parsed.baseName });
    }

    var groups = {};
    for (var j = 0; j < products.length; j++) {
      if (!products[j].color) continue;
      var key = products[j].baseName.toLowerCase().trim();
      if (!groups[key]) groups[key] = [];
      groups[key].push(products[j]);
    }

    var keys = Object.keys(groups);
    for (var k = 0; k < keys.length; k++) {
      var group = groups[keys[k]];
      for (var m = 0; m < group.length; m++) {
        var current = group[m];
        var infoEl = current.wrapper.querySelector('.card-information');
        if (!infoEl || infoEl.querySelector('.card-swatches')) continue;
        var row = document.createElement('div');
        row.className = 'card-swatches';
        row.setAttribute('aria-label', 'Available colours');
        for (var n = 0; n < group.length; n++) {
          var sib = group[n];
          var a = document.createElement('a');
          a.href = sib.url;
          a.className = 'card-swatch' + (sib === current ? ' card-swatch--active' : '');
          a.setAttribute('title', sib.title);
          var dot = document.createElement('span');
          dot.className = 'card-swatch__dot';
          if (COLOR_HEX[sib.color]) dot.style.backgroundColor = COLOR_HEX[sib.color];
          a.appendChild(dot);
          row.appendChild(a);
        }
        infoEl.appendChild(row);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildSwatches);
  } else {
    buildSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  var COLOR_HEX = {
    black: '#1a1a1a', white: '#f0f0f0', grey: '#8c8c8c', gray: '#8c8c8c',
    mint: '#6dc5a8', blue: '#4a7ebd', green: '#3d7a4a', navy: '#1a2a5c',
    red: '#c0392b', pink: '#e89eb0', purple: '#6b3fa0', yellow: '#f0c430',
    orange: '#e67e22', brown: '#7d4e2d', cream: '#e8dcc8', beige: '#e8dcc8',
    stone: '#c2b08a', khaki: '#c4b46a', olive: '#6b7c3e',
    'light blue': '#8bbdd9', 'dark blue': '#1a2a6c',
    'light grey': '#c8c8c8', 'light gray': '#c8c8c8', 'dark green': '#1e4d2b'
  };

  var MULTI = Object.keys(COLOR_HEX)
    .filter(function (k) { return k.indexOf(' ') !== -1; })
    .sort(function (a, b) { return b.length - a.length; });

  function extractColor(title) {
    var lower = title.toLowerCase();
    for (var i = 0; i < MULTI.length; i++) {
      if (lower.indexOf(MULTI[i] + ' ') === 0) {
        return { color: MULTI[i], baseName: title.slice(MULTI[i].length + 1) };
      }
    }
    var sp = title.indexOf(' ');
    if (sp < 0) return { color: null, baseName: title };
    var primary = title.slice(0, sp).split('/')[0].toLowerCase();
    if (Object.prototype.hasOwnProperty.call(COLOR_HEX, primary)) {
      return { color: primary, baseName: title.slice(sp + 1) };
    }
    return { color: null, baseName: title };
  }

  function buildProductSwatches() {
    var mount = document.querySelector('.product-page-swatches-mount');
    if (!mount) return;

    var titleEl = document.querySelector('.product__title h1');
    if (!titleEl) return;

    var title = titleEl.textContent.trim();
    var parsed = extractColor(title);
    if (!parsed.color) return;

    var baseName = parsed.baseName.toLowerCase().trim();

    var seen = {};
    var siblings = (window.__swatchCandidates || []).filter(function (p) {
      if (seen[p.url]) return false;
      seen[p.url] = true;
      var sp = extractColor(p.title);
      return sp.color && sp.baseName.toLowerCase().trim() === baseName;
    });

    var row = document.createElement('div');
    row.className = 'card-swatches product-page-swatches';

    var cur = document.createElement('a');
    cur.href = window.location.pathname;
    cur.className = 'card-swatch card-swatch--active';
    cur.setAttribute('title', title);
    var curDot = document.createElement('span');
    curDot.className = 'card-swatch__dot';
    if (COLOR_HEX[parsed.color]) curDot.style.backgroundColor = COLOR_HEX[parsed.color];
    cur.appendChild(curDot);
    row.appendChild(cur);

    siblings.forEach(function (sib) {
      var sp = extractColor(sib.title);
      var a = document.createElement('a');
      a.href = sib.url;
      a.className = 'card-swatch';
      a.setAttribute('title', sib.title);
      var dot = document.createElement('span');
      dot.className = 'card-swatch__dot';
      if (sp.color && COLOR_HEX[sp.color]) dot.style.backgroundColor = COLOR_HEX[sp.color];
      a.appendChild(dot);
      row.appendChild(a);
    });

    mount.parentNode.insertBefore(row, mount);
    mount.remove();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildProductSwatches);
  } else {
    buildProductSwatches();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
